import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  rootBox: {
    position: "relative",
    height: "calc(100vh - 120px)",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#fcfcfd",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.05)",
      borderRadius: "10px",
    },
  },
  decorationBlob: {
    position: "absolute",
    top: "-150px",
    right: "-100px",
    width: "500px",
    height: "500px",
    background:
      "radial-gradient(circle, rgba(225, 48, 108, 0.04) 0%, rgba(131, 58, 180, 0.02) 50%, transparent 100%)",
    borderRadius: "50%",
    filter: "blur(60px)",
    zIndex: 0,
    pointerEvents: "none",
  },
  stickyHeader: {
    position: "sticky",
    top: "0px",
    zIndex: 10,
    margin: "0 -30px",
    padding: "0 30px",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  loadingCircularProgressBox: {
    height: "calc(100vh - 200px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dynamicHeightLoggedIn: {
    height: "calc(100vh - 300px)",
    overflowY: "auto",
  },
  dynamicHeightLoggedOut: {
    height: "calc(100vh - 350px)",
    overflowY: "auto",
  },
  div: {
    width: "100%",
    height: "calc(100vh - 230px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 260px)",
    },
    "&:hover": {
      backgroundColor: "#FFFFFF",
      color: "#000000",
    },
  },
  progress: {
    marginBottom: "10px",
  },
  cardContent: {
    padding: 0,
    margin: 0,
    paddingTop: 10,
  },
  root: {
    // height: "50vh",
    padding: 0,
    margin: 0,
    overflowY: "auto",
  },
}));

export default useStyle;
